import React from "react";

import TableCell from "@material-ui/core/TableCell";

class Data extends React.Component {
  render() {
    const { row, column } = this.props;

    let value = row[column.key];

    if (column.values) {
      value = parseInt(value);

      const find = column.values.find((item) => item.id === value);
      if (find) {
        value = find.name;
      }
    }

    if (column.format) {
      if (typeof column.format === "function") {
        value = column.format(value, row);
      }
    }

    return <TableCell scope="row">{value}</TableCell>;
  }
}

export default Data;
